import React from 'react';
import { Box, Flex, Text, Button } from '@chakra-ui/react';

export default function EmptyState({ emoji = '📄', title, subtitle, children, actionLabel, onAction }) {
  return (
    <Flex direction="column" align="center" justify="center" minH="40vh" color="gray.500">
      <Box fontSize="5xl" mb={2}><span role="img" aria-label="empty">{emoji}</span></Box>
      {title && <Text fontSize="xl" fontWeight="bold" mb={2}>{title}</Text>}
      {subtitle && <Text fontSize="md" mb={4}>{subtitle}</Text>}
      {children}
      {actionLabel && onAction ? (
        <Button colorScheme="blue" onClick={onAction} mt={2}>{actionLabel}</Button>
      ) : null}
    </Flex>
  );
}


